import { api } from 'shared/api';
import { EMI } from 'shared/model/types';
import { Card } from 'entities/card/model/types';
import { ApiResponse } from 'shared/model/types';
import { setCards } from 'shared/config/store/reducers/cardsSlice';

const cardsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAccountCards: build.query<
      ApiResponse<Array<Card>>,
      { accountId: number; emi: EMI }
    >({
      query: ({ accountId, emi }) => ({
        url: `/private/river/${accountId}/cards`,
        method: 'GET',
        params: { emi, limit: 10, offset: 0 },
      }),
      async onQueryStarted({ accountId, emi }, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (Array.isArray(data?.response)) {
          dispatch(setCards({ emi, accountId, cards: data.response }));
        }
      },
    }),
    getNumberAndCvn: build.query<ApiResponse<{ number: string; cvn: string; }>, { accountId: string, cardId: string }>({
      query: ({ accountId, cardId }) => ({
        url: `/private/river/${accountId}/card/${cardId}/info`,
        method: 'GET'
      })
    }),
    getCardInfo: build.query<ApiResponse<Card>, ({
      accountId: string,
      cardId: string
    })>({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/${cardId}`,
        method: 'GET'
      })
    }),
  }),
});

export const {
  useLazyGetNumberAndCvnQuery,
  useLazyGetCardInfoQuery,
  useGetAccountCardsQuery,
} = cardsApi;

export default cardsApi;
